import { render, staticRenderFns } from "./LargeSearchBox.vue?vue&type=template&id=4ba0b4a5&scoped=true"
import script from "./LargeSearchBox.vue?vue&type=script&lang=js"
export * from "./LargeSearchBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba0b4a5",
  null
  
)

export default component.exports